import styled from 'styled-components';

interface DividerProps {
  borderHeight?: number;
  borderType?: string;
  color?: string;
}

const Divider = styled.div<DividerProps>`
  width: 100%;
  border-bottom: ${({ borderType }) => borderType} ${({ borderHeight }) => borderHeight}px ${({ color }) => color};
`;

Divider.defaultProps = {
  borderHeight: 1,
  borderType: 'solid',
  color: 'black'
};

export { Divider };
